import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { PainMirror } from './components/PainMirror';
import { OldSolutionsFail } from './components/OldSolutionsFail';
import { ProtocolReveal } from './components/ProtocolReveal';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ForWhom } from './components/ForWhom';
import { HowToUse } from './components/HowToUse';
import { FAQ } from './components/FAQ';
import { OfferCTA } from './components/OfferCTA';
import { FooterClose } from './components/FooterClose';
export function App() {
  useEffect(() => {
    initMetaPixel('782547894469810');
    trackPageView();
  }, []);
  return <main className="min-h-screen w-full bg-[#1a2332] overflow-x-hidden selection:bg-[#c9a04e] selection:text-[#1a2332]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainMirror data-id="element-2" />
      <OldSolutionsFail data-id="element-3" />
      <ProtocolReveal data-id="element-4" />
      <WhatsIncluded data-id="element-5" />
      <ForWhom data-id="element-6" />
      <HowToUse data-id="element-7" />
      <FAQ data-id="element-8" />
      <OfferCTA data-id="element-9" />
      <FooterClose data-id="element-10" />
    </main>;
}